import React, { useEffect } from 'react';
import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router';
import { ModalProvider } from '../contexts/ModalContext';
import {
  DeleteConversationModal,
  RenameConversationModal,
} from '../components/modals';
import { useLayoutStore } from '../store/layoutStore';
import { usePleriRender } from '../components/Pleri/context/PleriRenderContext';
import { MiniLayout } from './layouts/MiniLayout';
import { FullScreenLayout } from './layouts/FullScreenLayout';
import { ExtensionLayout } from './layouts/ExtensionLayout';

const nonFullScreenRoutes = ['trigger', 'mini', 'onboarding'];

// Routes that support mini layout when in mini mode
const miniSupportedRoutes = [
  '/pleri/c', // Matches both /c (list) and /c/$conversationId (individual conversation)
  '/c', // New router excludes /pleri, TODO: Remove the above /pleri/c once this is validated
];

export const Route = createRootRoute({
  component: function RootRoute() {
    const location = useLocation();
    const { isMiniMode } = useLayoutStore();
    const isNonFullScreenRoute = nonFullScreenRoutes.some((route) =>
      location.pathname.includes(route),
    );
    const isTriggerRoute = location.pathname.includes('trigger');
    const { open, renderType } = usePleriRender();

    // Check if current route supports mini layout
    const isMiniSupportedRoute = miniSupportedRoutes.some((route) =>
      location.pathname.startsWith(route),
    );

    useEffect(() => {
      if (open && !isTriggerRoute) {
        open();
      }
    }, [open, isTriggerRoute]);

    if (renderType === 'extension') {
      return (
        <ModalProvider>
          <ExtensionLayout />

          {/* Global modals */}
          <DeleteConversationModal />
          <RenameConversationModal />

          {/* <TanStackRouterDevtools /> */}
        </ModalProvider>
      );
    }
    // 1. First check if it's trigger route
    if (isTriggerRoute) {
      return (
        <ModalProvider>
          <div className="flex h-screen w-full overflow-hidden">
            {/* Empty space that gets pushed left automatically by flex */}
            <div className="flex-1" />
            <Outlet />
          </div>

          {/* Global modals */}
          <DeleteConversationModal />
          <RenameConversationModal />

          {/* <TanStackRouterDevtools /> */}
        </ModalProvider>
      );
    }
    if (isNonFullScreenRoute) {
      return <Outlet />;
    }

    // 2. Check if it's mini mode AND route supports mini layout
    const shouldShowMiniLayout = isMiniMode && isMiniSupportedRoute;

    return (
      <ModalProvider>
        {shouldShowMiniLayout ? (
          <MiniLayout />
        ) : (
          <FullScreenLayout minimize={isNonFullScreenRoute} />
        )}

        {/* Global modals */}
        <DeleteConversationModal />
        <RenameConversationModal />

        {/* <TanStackRouterDevtools /> */}
      </ModalProvider>
    );
  },
});
